import axios from 'axios';
const URL = 'https://api.openweathermap.org/data/2.5/weather';
const key = "a8776030970a49477b7cbdeb2cd6754d";
export const fetchWeather = async (query) => {
    const { data } = await axios.get(URL, {
        params: {
            q: query,
            units: 'metric',
            APPID: key
        }
    });
    return data;
}
